module.exports = __webpack_public_path__ + "media/application/images/svgs/instagram-contact-c4a2a4b8617e6ef16d93719daf077226.svg";